/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateVoucherDto } from '../../models/create-voucher-dto';
import { VoucherDto } from '../../models/voucher-dto';

export interface CenterVoucherControllerCreate$Params {
  centerId: string;
      body: CreateVoucherDto
}

export function centerVoucherControllerCreate(http: HttpClient, rootUrl: string, params: CenterVoucherControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<VoucherDto>> {
  const rb = new RequestBuilder(rootUrl, centerVoucherControllerCreate.PATH, 'post');
  if (params) {
    rb.query('centerId', params.centerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VoucherDto>;
    })
  );
}

centerVoucherControllerCreate.PATH = '/api/voucher/center';
